/**
 *
 * @class ErrorPopupEvent
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/model/Document.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

class ErrorPopupEvent {
  constructor(mutation, message) {
    this.show = true
    this.message = message;

    this._mutation = mutation
    this._isValidationError = false
    this._errors = [];
  }

  get mutation() {
    return this._mutation;
  }

  get isValidationError() {
    return this._isValidationError;
  }

  get errors() {
    return this._errors;
  }
}

export default ErrorPopupEvent